import { FPcheckMail } from "../../components";
import './ForgotPasswordCM.css'

const ForgotPasswordCM = ()=>{
    return (
        <div className='fpcm-page'>
            <FPcheckMail/>
        </div>
    )
};

export default ForgotPasswordCM;